import * as Yup from "yup";

export const useThermoConfig = (t, cameras) => ({
    initialThermoValues: {
        manual: "",
        download: "",
        camera: "",
        certificate: "",
        calibration: "",
        misc: "",
        device: "",
        serial: "",
        tFirstname: "",
        tLastname: "",
        tCompany: "",
        tCountry: "",
        tCity: "",
        tEmail: "",
        tPhone: "",
        tCustomer: "",
        tGdpr: ""
    },
    thermoSchema: {
        manual: Yup.boolean(),
        download: Yup.boolean(),
        camera: Yup.boolean(),
        certificate: Yup.boolean(),
        calibration: Yup.boolean(),
        misc: Yup.boolean(),
        device: Yup.string()
            .required(t("form.registration.device.error"))
            .oneOf([...(cameras.nodes.map(n => n.name))]
        ),
        
        serial: Yup.string().required(
            t("form.registration.serial.error")
        ),
        tFirstname: Yup.string().required(
            t("form.registration.firstname.error")
        ),
        tLastname: Yup.string().required(
            t("form.registration.lastname.error")
        ),
        tCompany: Yup.string().required(
            t("form.registration.company.error")
        ),
        tCountry: Yup.string().required(
            t("form.registration.country.error")
        ),
        tCity: Yup.string().required(
            t("form.registration.city.error")
        ),
        tEmail: Yup.string()
            .email()
            .required(t("form.registration.email.error")
        ),
        tPhone: Yup.number().required(
            t("form.registration.phone.error")
        ),
        tCustomer: Yup.string(),
        info: Yup.string(),
        tGdpr: Yup.boolean()
            .oneOf(
                [true],
                t("form.registration.privacypolicy.error")
            )
            .required(t("form.registration.privacypolicy.error")
        )
    }
})